import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/PortalIndex.vue')
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('../views/MapIndex.vue')
  }
  ,
  {
    path: '/:iframePath(.*)?',
    name: 'iframe',
    component: () => import('../views/IframeIndex.vue')
  }
  ,
  {
    // path: '/content/:contentPath?',
    path: '/content/:rootPageName?/:pageId?',
    name: 'content',
    props: true,
    component: () => import('../views/ContentIndex.vue')
    // props: route => ({
    //   contentPath: `${route.params.rootPageName}/${route.params.pageId}${route.params.language ? '/' + route.params.language : ''}`
    // })
    
  }
  ,
  {
    path: '/news/:newsId?',
    name: 'news',
    component: () => import('../views/NewsIndex.vue')
  }
  ,
  {
    path: '/investorRelation',
    name: 'ir',
    component: () => import('../components/content/investorRelation/InvestorRelationPage.vue'),
    children: [{
      path: ':subPath',
      name: 'investorRelationSub',
      component: () => import('../components/content/investorRelation/InvestorRelationPage.vue'),
    }]
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../components/PrivacyPolicy.vue')
  },
  {
    path: '/siteMap',
    name: 'siteMap',
    component: () => import('../components/SiteMap.vue')
  },
  {
    path: '/termOfUse',
    name: 'termOfUse',
    component: () => import('../components/TermOfUse.vue')
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('../components/ContactUs.vue')
  },
  // {
  //   path: '/content/investorRelation',
  //   name: 'ir',
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('../components/content/investorRelation/InvestorRelationPage.vue')
  //     },
      // {
      //   // 注意，嵌套時 path 不帶 "/"
      //   path: 'irContact',
      //   component: ProductsA
      // },
      // {
      //   path: 'downloadLibrary',
      //   component: ProductsB
      // },
      // {
      //   path: 'irFQA',
      //   component: ProductsA
      // },
      // {
      //   path: 'emailAlerts',
      //   component: ProductsB
      // }
    // ]
  // },
  {
    path: '/*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // history: createWebHistory('/'),
  mode: 'history',
  routes
})

export default router
